"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("./styles");
var material_1 = require("@mui/material");
var CategoricMenu_1 = __importDefault(require("../CategoricMenu"));
var prism_icons_1 = require("@octanner/prism-icons");
var Layout_1 = __importDefault(require("../context/Layout"));
var StoreButton = function (_a) {
    var _b;
    var _c = _a.multipleBanksObj, hasMultipleBank = _c.hasMultipleBank, multipleBanks = _c.multipleBanks, suppliedSpecialPointName = _c.suppliedSpecialPointName, vibesPointName = _c.vibesPointName, bank = _c.bank, bankUrl = _c.bankUrl, handleNavigation = _a.handleNavigation, vibePointLoading = _a.vibePointLoading;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = __read((0, react_1.useContext)(Layout_1.default), 3), __ = _d[0], layoutQuery = _d[1], _ = _d[2];
    var layout = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data;
    var hasRedeemPermission = (_b = layout === null || layout === void 0 ? void 0 : layout.hasRedeemAwardsPermission) === null || _b === void 0 ? void 0 : _b.hasRedeemAwardsPermission;
    var multipleBankOrder = [
        t('prism-header:bank-accounts', 'Bank Accounts'),
        t('prism-header:access-codes', 'Access Codes'),
    ];
    var getCorrectPointName = function () {
        var correctName = '';
        if (vibesPointName)
            correctName = vibesPointName;
        else if (suppliedSpecialPointName) {
            correctName = suppliedSpecialPointName;
        }
        else {
            correctName = t('prism-header:points', 'Points');
        }
        var totalPoints = typeof (bank === null || bank === void 0 ? void 0 : bank.points) === 'number' ? bank === null || bank === void 0 ? void 0 : bank.points.toLocaleString() : 0;
        return "".concat(totalPoints, " ").concat(correctName);
    };
    if (vibePointLoading) {
        return react_1.default.createElement(styles_1.StyledSkeleton, null);
    }
    if (!hasRedeemPermission) {
        return null;
    }
    if (!hasMultipleBank) {
        return (react_1.default.createElement(material_1.Button, { variant: "text", component: "a", disableRipple: true, sx: styles_1.buttonFocusOverride, "data-testid": "store-link", href: bankUrl, onClick: handleNavigation(bankUrl), target: "_blank" },
            t('prism-header:store'),
            react_1.default.createElement(styles_1.PointsBox, { component: "span" },
                "|",
                getCorrectPointName())));
    }
    else {
        return (react_1.default.createElement(CategoricMenu_1.default, { anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            }, buttonText: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.MarginRightDiv, null,
                    t('prism-header:store'),
                    react_1.default.createElement(styles_1.PointsBox, { component: "span" },
                        "|",
                        getCorrectPointName())),
                react_1.default.createElement(prism_icons_1.ArrowTriangleDown, null)), buttonVariant: "text", buttonSx: styles_1.buttonFocusOverride, "data-testid": "multiple-banks-menu", handleNavigationClick: handleNavigation, options: multipleBanks || [], sortOrder: multipleBankOrder, sx: styles_1.categoricMenuSX, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            } }));
    }
};
exports.default = StoreButton;
//# sourceMappingURL=StoreButton.js.map